module.exports = __webpack_public_path__ + "img/voucher-detail.b442d984.png";